import { useEffect } from 'react';
import { useCommDispatcher } from '@/hooks/comm/use-comm';
import useMarkSessionRead from '@/hooks/conversations/use-mark-session-read';
import { useSessionUnreadCount } from '@/hooks/sessions/use-conversation-sessions';
import useSessionSettings from '@/hooks/sessions/use-session-settings';
import type { ConversationType } from '@/models/conversations/conversation-session';

export default function useSessionEffect(type: ConversationType, id: number) {
  const { dispatch } = useCommDispatcher();
  const { markAllRead } = useMarkSessionRead();
  const { session } = useSessionSettings(type, id);

  useSessionUnreadCount(true);

  useEffect(() => {
    if (session?.LastMsgID) {
      markAllRead(type, id, session.LastMsgID);
    }
  }, [type, id, session?.LastMsgID]);

  useEffect(() => {
    dispatch({
      event: 'session',
      data: { type, id },
    });
  }, [type, id]);
}
